import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { GET_BULK_USERS, GET_BULK_USERS_SUCCESS, GET_BULK_USERS_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getBulkUser({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/user/v1/bulk-user`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'X-Requested-By': 'one-admin',
      },
      data: {
        ...payload?.data,
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BULK_USERS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BULK_USERS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BULK_USERS_ERROR, payload: error });
  }
}

export function* watchGetBulkUsers() {
  yield takeEvery(GET_BULK_USERS, getBulkUser);
}

function* getBulkUsersSaga() {
  yield all([fork(watchGetBulkUsers)]);
}

export default getBulkUsersSaga;
